import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getCargoTypeList(params) {
  return request({
    url: URL.mdm.basicData.cargoType,
    method: 'get',
    params
  })
}

export function saveCargoType(data) {
  return request({
    url: URL.mdm.basicData.cargoType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delCargoType(uuid) {
  return request({
    url: URL.mdm.basicData.cargoType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export function dragCargoType(data) {
  return request({
    url: URL.mdm.dragCargoType,
    method: 'post',
    data
  })
}

